import React from 'react'

import { useNavigate } from 'react-router-dom'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { Button, ThemeProvider } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Header from '../../../components/header/Header'
import styles from '../Rewards.module.scss'
import { coupons, getRandomValue } from '../components/Categories'
import theme from '../../../theme/theme'

export default function RewardsHistory() {
  const columns: GridColDef[] = [
    {
      field: 'invoiceDate',
      headerName: 'Data',
      headerAlign: 'center',
      align: 'center',
      flex: 1
    },
    {
      field: 'invoiceType',
      headerName: 'Tipo',
      flex: 1,
      sortable: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'invoiceValue',
      headerName: 'Valor',
      sortable: true,
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'invoicePaymentType',
      headerName: 'Localização',
      sortable: true,
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'couponsGenerated',
      headerName: 'Cupons Gerados',
      sortable: true,
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'couponsRewarded',
      headerName: 'Cupons Resgatados',
      sortable: true,
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    }
  ]
  const navigate = useNavigate()

  return (
    <div className={styles.rewards}>
      <Header />
      <div className={styles.rewardsWrapper}>
        <div className="d-flex flex-column align-items-center w-100">
          <h4>HISTÓRICO</h4>
          <h5>{`Você já resgatou R$ ${getRandomValue(50, 150)},00`}</h5>
        </div>
        <hr />
        <div className={styles.categoriesTableWrapper}>
          <ThemeProvider theme={theme}>
            <div className={styles.grid}>
              <DataGrid
                sx={{ fontSize: 48 }}
                rows={coupons}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 6
                    }
                  }
                }}
                density="comfortable"
                pageSizeOptions={[10, 15, 25, 50, 100]}
                disableRowSelectionOnClick
              />
            </div>
          </ThemeProvider>
        </div>
        <div className="d-flex flex-column align-items-center">
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/rewards')}
            className="text-center mt-3"
          >
            <ArrowBackIcon fontSize="small" className="me-2" />
            {` VOLTAR`}
          </Button>
        </div>
      </div>
    </div>
  )
}
